import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

const getWellnessRewards = async function(rewardId = null) {
    const db = firebase.firestore();
    let rewardsSnapshot = await db.collection('wellness_rewards').get();
    if(rewardId){
        rewardsSnapshot = await db.collection('wellness_rewards').doc(rewardId).get();
        rewardsSnapshot = [rewardsSnapshot];
    }
    
    const rewards = [];
    rewardsSnapshot.forEach(doc => {
        rewards.push({
            id: doc.id,
            ...doc.data()
        });
    });

    //get userinfo for updatedBy
    for(let i = 0; i < rewards.length; i++){
        rewards[i].remainingCount = rewards[i].totalQuantity;
        if(rewards[i].totalQuantity && rewards[i].redeemCount){
            rewards[i].remainingCount = (rewards[i].totalQuantity*1) - (rewards[i].redeemCount*1);
        }
        if(rewards[i].remainingCount < 0){
            rewards[i].remainingCount = 0;
        }
    }
    
    return rewards;
};

export default getWellnessRewards; 